import { render, staticRenderFns } from "./PermitControls.vue?vue&type=template&id=e59b838e"
import script from "./PermitControls.vue?vue&type=script&lang=js"
export * from "./PermitControls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports